import React, { Component } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import NavbarData from './NavbarModel/NavbarData';
import NavbarItem from './NavbarModel/NavbarItem';
import NavbarService from '../../Services/Navbar/NavbarService';

export default class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      NavbarData: new NavbarData(),
      isLoading: true,
      error: null,
      isMobileMenuOpen: false
    };
    this._NavbarService = new NavbarService();
  }
  
  
  async componentDidMount() {

    try 
    {
    
      const navbarData = await this._NavbarService.getNavbarData();
      this.setState({
        NavbarData: navbarData,
        isLoading: false,
        error: null
      });
    }
    catch (error)
    {
      console.error("Error fetching navbar data:", error);
    }
  

    this.forceUpdate();
  }

  componentWillUnmount() {
  }

  handleMenuToggle = () => {
    this.setState(prevState => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen
    }));
  }
  handleLinkClick = () => {
    this.setState({
      isMobileMenuOpen: false
    });
  }
  render() {
    const { NavbarData ,isLoading,error,isMobileMenuOpen} = this.state;
    
    return (
      <nav className="navbar">
        <Link to={NavbarData.LogoLinkTo} className="logo">{NavbarData.LogoName}</Link>
        <div className={`menu-toggle ${isMobileMenuOpen ? 'active' : ''}`} id="menu-toggle" onClick={this.handleMenuToggle}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul id="nav-links" className={isMobileMenuOpen ? 'active' : ''} >
          {NavbarData.NavbarItems.map((item, index) => (
            <li key={index}>
              <Link to={item.LinkTo} onClick={this.handleLinkClick}>{item.LinkName}</Link>
            </li>
          ))}
        </ul>
      </nav>
    );
  }
}

